import {InputAdornment} from '@mui/material'
import {useGetAccountsQuery, useGetCurrentUserQuery} from 'store/Store'
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded'
import {z} from 'zod'
import {getDocumentId} from 'utils'

const accountData = {
    name: 'account',
    type: 'autocomplete',
    label: 'account',
    rules: {required: true},
    // defaultValueFieldName: 'account._id',
    sm: 3,
    xs: 12,
    InputProps: {
        startAdornment: (
            <InputAdornment position="start">
                <PeopleAltRoundedIcon />
            </InputAdornment>
        ),
    },
}

const useFromFieldWithAccount = ({
    fieldsCreate,
    fieldsEdit,
    validationSchema,
    withoutAccount = false,
    validationSchemaSuperRefine = () => true,
    accountIsOptional = false,
}) => {
    const {data: user} = useGetCurrentUserQuery()
    const {data: accounts, isLoading} = useGetAccountsQuery({}, {skip: !!user?.account})

    if (user?.account || withoutAccount) {
        return {
            fieldsCreate,
            fieldsEdit,
            validationSchema,
        }
    } else {
        const account = {
            title: 'accountSelect',
            items: {
                account: {
                    ...accountData,
                    options: accounts?.data,
                },
            },
        }

        const accountSchemaBase = z.preprocess(
            (value) => getDocumentId(value),
            z.string({message: 'account'})
        )

        const schemaWithAccount =
            validationSchema &&
            validationSchema
                .extend({
                    account: accountIsOptional
                        ? accountSchemaBase.optional().nullish()
                        : accountSchemaBase,
                })
                .superRefine(validationSchemaSuperRefine)

        return {
            fieldsCreate: {
                account,
                ...fieldsCreate,
            },
            fieldsEdit: {
                account,
                ...fieldsEdit,
            },
            validationSchema: schemaWithAccount,
            isLoading,
        }
    }
}

export default useFromFieldWithAccount
